import { Response } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import { EquipmentInspectionV } from '../../entities/equipment/model';
import { GeneralInspectionModel, EquipmentPhotoModel, AdditionalRecordOverviewModel, AdditionalRecordModel, ComponentRecord, MeasurementPointPhoto, MandatoryCompartPhoto, MandatoryEquipmentPhotoModel, MandatoryCompartTypePhotoModel, MeasurementPointPhotoModel, NewMeasurementPointPhotoModel, ToolList, ReportConfigVM } from './models/rope-shovel.model';
import { Tuple, Tuple3 } from '../../entities';
import { catchError } from 'rxjs/operators';
@Injectable()
export class RopeShovelService {

  constructor(private _http: HttpClient) { }

    public getUserUom(): Observable<any> {
      return this._http.get("Api/WSRE/GetUserUOM").pipe(catchError(this.handleError));
    }

    public getInspectionEquipment(Id: number, inspectionId: number): Observable<EquipmentInspectionV> {
      let options = {
        params: new HttpParams().set('Id', Id.toString()).set('inspectionId', inspectionId.toString())
      };
      return this._http.get<EquipmentInspectionV>("Api/Equipment/getInspectionEquipmentInfo", options).pipe(catchError(this.handleError));
    }

    public getInspectionGeneralAsync(inspectionId: number): Observable<GeneralInspectionModel> {
      let options = {
        params: new HttpParams().set('Id', inspectionId.toString())
      };
      return this._http.get<GeneralInspectionModel>("Api/RopeShovelInspection/GetInspectionGeneralAsync", options).pipe(catchError(this.handleError));
    }

    public InspectionAction(body: GeneralInspectionModel): Observable<GeneralInspectionModel> {
      return this._http.post<GeneralInspectionModel>("Api/RopeShovelInspection/InspectionAction", body).pipe(catchError(this.handleError));
    }

    public ReCalculateWornPercentage(inspectionId: number): Observable<any> {
      let options = {
        params: new HttpParams().set('Id', inspectionId.toString())
      };
      return this._http.get("Api/RopeShovelInspection/ReCalculateWornForInspection", options).pipe(catchError(this.handleError));
    }

    public getMandatoryPhotosAsync(inspectionId: number): Observable<EquipmentPhotoModel[]> {
      let options = {
        params: new HttpParams().set('Id', inspectionId.toString())
      };
      return this._http.get<EquipmentPhotoModel[]>("Api/RopeShovelInspection/GetMandatoryPhotosAsync", options).pipe(catchError(this.handleError));
    }

    public getAdditionalRecordsForInspectionCompartType(inspectionId: number, compartTypeId: number, side: string): Observable<AdditionalRecordOverviewModel[]> {
      let options = {
        params: new HttpParams().set('inspectionId', inspectionId.toString()).set('compartTypeId', compartTypeId.toString()).set('side', side)
      };
      return this._http.get<AdditionalRecordOverviewModel[]>("Api/RopeShovelInspection/GetAdditionalRecordsAsync", options).pipe(catchError(this.handleError));
    }

    public getMandatoryPhotosForInspectionCompartType(inspectionId: number, compartTypeId: number, side: string): Observable<EquipmentPhotoModel[]> {
      let options = {
        params: new HttpParams().set('inspectionId', inspectionId.toString()).set('compartTypeId', compartTypeId.toString()).set('side', side)
      };
      return this._http.get<EquipmentPhotoModel[]>("Api/RopeShovelInspection/GetMandatoryPhotosForCompartTypeAsync", options).pipe(catchError(this.handleError));
    }

    public getAdditionalRecordDetails(recordId: number, id: number, side: string, inspectionId: number): Observable<AdditionalRecordModel> {
      let options = {
        params: new HttpParams().set('recordId', recordId.toString()).set('id', id.toString()).set('side', side).set('inspectionId', inspectionId.toString())
      };
      return this._http.get<AdditionalRecordModel>("Api/RopeShovelInspection/GetAdditionalRecordDetailsAsync", options).pipe(catchError(this.handleError));
    }

    public updateAdditionalRecord(recordId: number, id: number, side: string, inspectionId: number, reading: string): Observable<Tuple> {
      let options = {
        params: new HttpParams().set('recordId', recordId.toString()).set('id', id.toString()).set('side', side).set('inspectionId', inspectionId.toString()).set('reading', reading)
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/UpdateAdditionalRecordAsync", options).pipe(catchError(this.handleError));
    }

    public getInspectionComponentMeasurementsForCompartTypeAsync(inspectionId: number, compartTypeId: number, side: string, uom: string): Observable<ComponentRecord[]> {
      let options = {
        params: new HttpParams().set('inspectionId', inspectionId.toString()).set('compartTypeId', compartTypeId.toString()).set('side', side).set('uom', uom)
      };
      return this._http.get<ComponentRecord[]>("Api/RopeShovelInspection/GetInspectionComponentMeasurementsForCompartTypeAsync", options).pipe(catchError(this.handleError));
    }

    public getMeasurementPointPhotoThumbnail(photoId: number): Observable<MeasurementPointPhoto> {
      let options = {
        params: new HttpParams().set('photoId', photoId.toString())
      };
      return this._http.get<MeasurementPointPhoto>("Api/RopeShovelInspection/GetMeasurementPointPhotoThumbnail", options).pipe(catchError(this.handleError));
    }

    public getMeasurementPointPhoto(photoId: number): Observable<MeasurementPointPhoto> {
      let options = {
        params: new HttpParams().set('photoId', photoId.toString())
      };
      return this._http.get<MeasurementPointPhoto>("Api/RopeShovelInspection/GetMeasurementPointPhoto", options).pipe(catchError(this.handleError));
    }

    public getMandatoryImagePhotoThumbnail(photoId: number): Observable<MeasurementPointPhoto> {
      let options = {
        params: new HttpParams().set('photoId', photoId.toString())
      };
      return this._http.get<MeasurementPointPhoto>("Api/RopeShovelInspection/GetCompartMandatoryImagePhotoThumbnail", options).pipe(catchError(this.handleError));
    }

    public getMandatoryCompartPhotoAsync(photoId: number): Observable<MeasurementPointPhoto> {
      let options = {
        params: new HttpParams().set('photoId', photoId.toString())
      };
      return this._http.get<MeasurementPointPhoto>("Api/RopeShovelInspection/GetCompartMandatoryImagePhoto", options).pipe(catchError(this.handleError));
    }

    public updateTrammingHours(inspectionId: number, trammingHours: number): Observable<Tuple> {
      let options = {
        params: new HttpParams().set('inspectionId', inspectionId.toString()).set('trammingHours', trammingHours.toString())
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/UpdateTrammingHoursAsync", options).pipe(catchError(this.handleError));
    }

    public updateNumberOfShoesLeft(inspectionId: number, num_of_shoe: number): Observable<Tuple> {
      let options = {
        params: new HttpParams().set('inspectionId', inspectionId.toString()).set('num_of_shoe', num_of_shoe.toString())
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/updateNumberOfShoesLeftAsync", options).pipe(catchError(this.handleError));
    }

    public updateNumberOfShoesRight(inspectionId: number, num_of_shoe: number): Observable<Tuple> {
      let options = {
        params: new HttpParams().set('inspectionId', inspectionId.toString()).set('num_of_shoe', num_of_shoe.toString())
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/updateNumberOfShoesRightAsync", options).pipe(catchError(this.handleError));
    }

    public updateCustomerContact(inspectionId: number, customerContact: string): Observable<Tuple> {
      let options = {
        params: new HttpParams().set('inspectionId', inspectionId.toString()).set('customerContact', customerContact.toString())
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/UpdateCustomerContactAsync", options).pipe(catchError(this.handleError));
    }

    public updateGeneralInspectionNotes(inspectionId: number, generalInspectionNotes: string): Observable<Tuple> {
      let options = {
        params: new HttpParams().set('inspectionId', inspectionId.toString()).set('generalInspectionNotes', generalInspectionNotes.toString())
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/UpdateGeneralInspectionNotesAsync", options).pipe(catchError(this.handleError));
    }

    public updateInterpComment(inspectionId: number, generalInspectionNotes: string): Observable<Tuple> {
      let options = {
        params: new HttpParams().set('inspectionId', inspectionId.toString()).set('generalInspectionNotes', generalInspectionNotes.toString())
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/updateInterpCommentAsync", options).pipe(catchError(this.handleError));
    }


    public updateImpact(inspectionId: number, impact: number): Observable<Tuple> {
      let options = {
        params: new HttpParams().set('inspectionId', inspectionId.toString()).set('impact', impact.toString())
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/UpdateImpactAsync", options).pipe(catchError(this.handleError));
    }

    public updateAbrasive(inspectionId: number, abrasive: number): Observable<Tuple> {
      let options = {
        params: new HttpParams().set('inspectionId', inspectionId.toString()).set('abrasive', abrasive.toString())
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/UpdateAbrasiveAsync", options).pipe(catchError(this.handleError));
    }

    public updateMoisture(inspectionId: number, moisture: number): Observable<Tuple> {
      let options = {
        params: new HttpParams().set('inspectionId', inspectionId.toString()).set('moisture', moisture.toString())
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/UpdateMoistureAsync", options).pipe(catchError(this.handleError));
    }

    public updatePacking(inspectionId: number, packing: number): Observable<Tuple> {
      let options = {
        params: new HttpParams().set('inspectionId', inspectionId.toString()).set('packing', packing.toString())
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/UpdatePackingAsync", options).pipe(catchError(this.handleError));
    }

    public updateJobsiteComment(inspectionId: number, jobsiteComment: string): Observable<Tuple> {
      let options = {
        params: new HttpParams().set('inspectionId', inspectionId.toString()).set('comment', jobsiteComment.toString())
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/UpdateOverallJobsiteCommentAsync", options).pipe(catchError(this.handleError));
    }

    public updateMeasurementPointComment(inspectionDetailId: number, compartMeasurePointId: number, comment: string): Observable<Tuple> {
      let options = {
        params: new HttpParams().set('inspectionDetailId', inspectionDetailId.toString()).set('comment', comment.toString()).set('compartMeasurePointId', compartMeasurePointId.toString())
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/UpdateMeasurementPointCommentAsync", options).pipe(catchError(this.handleError));
    }

    public updateMeasurementPointReading(inspectionDetailId: number, compartMeasurePointId: number, readingNumber: number, reading: number): Observable<Tuple> {
      let options = {
        params: new HttpParams().set('inspectionDetailId', inspectionDetailId.toString()).set('readingNumber', readingNumber.toString()).set('compartMeasurePointId', compartMeasurePointId.toString()).set('reading', reading.toString())
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/UpdateMeasurementPointReadingAsync", options).pipe(catchError(this.handleError));
    }

    public updateMeasurementPointEstimate(inspectionDetailId: number, compartMeasurePointId: number, readingNumber: number, IsEstimate: boolean): Observable<Tuple> {
      let options = {
        params: new HttpParams().set('inspectionDetailId', inspectionDetailId.toString()).set('readingNumber', readingNumber.toString()).set('compartMeasurePointId', compartMeasurePointId.toString()).set('IsEstimate', IsEstimate.toString())
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/UpdateMeasurementPointReadingEstimateAsync", options).pipe(catchError(this.handleError));
    }


    public uploadEquipmentMandatoryPhoto(photo: MandatoryEquipmentPhotoModel): Observable<Tuple> {
      return this._http.post<Tuple>("Api/RopeShovelInspection/UploadEquipmentMandatoryPhoto", photo).pipe(catchError(this.handleError));
    }

    public uploadCompartMandatoryPhoto(photo: MandatoryCompartTypePhotoModel): Observable<Tuple> {
      return this._http.post<Tuple>("Api/RopeShovelInspection/UploadCompartTypeMandatoryPhoto", photo).pipe(catchError(this.handleError));
    }

    public uploadMeasurementPointPhoto(photo: MeasurementPointPhotoModel): Observable<Tuple> {
      return this._http.post<Tuple>("Api/RopeShovelInspection/UploadMeasurementPointPhoto", photo).pipe(catchError(this.handleError));
    }

    public uploadNewMeasurementPointPhoto(photo: NewMeasurementPointPhotoModel): Observable<Tuple> {
      return this._http.post<Tuple>("Api/RopeShovelInspection/UploadNewMeasurementPointPhoto", photo).pipe(catchError(this.handleError));
    }

    public uploadNewAdditionalRecordPhoto(photo: NewMeasurementPointPhotoModel): Observable<Tuple> {
      return this._http.post<Tuple>("Api/RopeShovelInspection/uploadNewAdditionalRecordPhoto", photo).pipe(catchError(this.handleError));
    }
    public deleteMeasurementPointPhoto(photoId: number): Observable<Tuple> {
        let options = {
            params: new HttpParams().set('photoId', photoId.toString())
        };
        return this._http.get<Tuple>("Api/RopeShovelInspection/DeleteMeasurementPointPhoto", options).pipe(catchError(this.handleError));
    }

    // Comparttype mandatory photo
    public deleteMandatoryPhoto(photoId: number): Observable<Tuple> {
        let options = {
            params: new HttpParams().set('photoId', photoId.toString())
        };
        return this._http.get<Tuple>("Api/RopeShovelInspection/DeleteMandatoryPhoto", options).pipe(catchError(this.handleError));
    }

    // Equipment mandatory photo
    public deleteEquipmentMandatoryPhoto(photoId: number): Observable<Tuple> {
        let options = {
            params: new HttpParams().set('photoId', photoId.toString())
        };
        return this._http.get<Tuple>("Api/RopeShovelInspection/DeleteEquipmentMandatoryPhoto", options).pipe(catchError(this.handleError));
    }

    public hasPermissionToDeletePhoto(photoId: number): Observable<any> {
        let options = {
            params: new HttpParams().set('photoId', photoId.toString())
        };
        return this._http.get("Api/RopeShovelInspection/HasPermissionToDeletePhoto", options).pipe(catchError(this.handleError));
    }

    public GetRSReportClient(): Observable<any> {
        let options = {
            params: new HttpParams()
        };
        return this._http.get("Api/MSInspection/GetRSReportClient", options).pipe(catchError(this.handleError));
    }

    public GetMeasuremenetPointPossibleTools(compartMeasurePointId: number): Observable<ToolList[]> {
      let options = {
        params: new HttpParams().set('compartMeasurePointId', compartMeasurePointId.toString())
      };
      return this._http.get<ToolList[]>("Api/RopeShovelInspection/GetMeasuremenetPointPossibleTools", options).pipe(catchError(this.handleError));
    }

    public UpdateToolForMeasurementPoint(compartMeasurePointId: number,ToolId:number, Id:number, inspectionDetailId:number): Observable<Tuple> {
      let options = {
        params: new HttpParams().set('compartMeasurePointId', compartMeasurePointId.toString()).set('ToolId', ToolId.toString()).set('Id', Id.toString()).set('inspectionDetailId', inspectionDetailId.toString())
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/UpdateToolForMeasurementPoint", options).pipe(catchError(this.handleError));
    }

    public UploadAdditonalPhoto(photo: MeasurementPointPhotoModel): Observable<Tuple> {
      return this._http.post<Tuple>("Api/RopeShovelInspection/UploadAdditonalPhoto", photo).pipe(catchError(this.handleError));
    }

    public DeleteAdditionalPhoto(photoId: number): Observable<Tuple> {
      let options = {
          params: new HttpParams().set('photoId', photoId.toString())
      };
      return this._http.get<Tuple>("Api/RopeShovelInspection/DeleteAdditionalPhoto", options).pipe(catchError(this.handleError));
  }

  public CreateNewRopeShovelInspection(EquipmentId: number, SMU: number,InspectionDate:string, Propel:number): Observable<Tuple3> {
    let options = {
      params: new HttpParams().set('EquipmentId', EquipmentId.toString()).set('SMU', SMU.toString()).set('InspectionDate', InspectionDate).set('Propel', Propel.toString())
    };
    return this._http.get<Tuple3>("Api/RopeShovelInspection/CreateNewRopeShovelInspection", options).pipe(catchError(this.handleError));
  }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
  }
  public getReportConfigData(inspectionId: number): Observable<ReportConfigVM[]> {
    return this._http.get<ReportConfigVM[]>("Api/RopeShovelInspection/GetRSReportConfigByInspectionId?inspectionId=" + inspectionId.toString()).pipe(catchError(this.handleError));
  }

  public setReportConfigData(ReportConfig: ReportConfigVM): Observable<any> {
    return this._http.post("Api/RopeShovelInspection/SetRSReportConfig", ReportConfig).pipe(catchError(this.handleError));
  }

  public SetRSReportMeasurementPointConfig(ReportConfig: ReportConfigVM): Observable<any> {
    return this._http.post("Api/RopeShovelInspection/SetRSReportMeasurementPointConfig", ReportConfig).pipe(catchError(this.handleError));
  }

  public checkReportConfig(inspectionId: number, quipmentId: number): Observable<any> {
    return this._http.get("Api/RopeShovelInspection/checkReportConfig?InspectionId=" + inspectionId.toString() + "&EquipmentId=" + quipmentId.toString()).pipe(catchError(this.handleError));
  }

  public recalculateSortOrder(configId: number, miningShovelReportId: number, sortOrder: number, incrementOrder: number):
    Observable<any> {
    const options = {
      params: new HttpParams().set('ConfigId', configId.toString()).set('SortOrder', sortOrder.toString()).set('IncrementOrder', incrementOrder.toString()).set('MiningShovelReportId', miningShovelReportId.toString())
    };
    return this._http.get('Api/RopeShovelInspection/RecalculateSortOrder', options)
      .pipe(catchError(this.handleError));
  }
  //public GetRSPdf(inspectionId: number): Observable<boolean> {
  //  return this._http.get("Api/RopeShovelInspection/GetRSPdf?InspectionId=" + inspectionId.toString()).pipe(catchError(this.handleError));
  //}

}
